export { default } from './SectionTabs';
